var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "12",
        height: "18",
        viewBox: "0 0 12 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M1.00038 1.08051C1.00038 0.49281 1.44725 0.0180054 2.00038 0.0180054H10.0004C10.5535 0.0180054 11.0004 0.49281 11.0004 1.08051C11.0004 1.6682 10.5535 2.14301 10.0004 2.14301H9.0785L9.43475 7.06371C10.5816 7.72445 11.4879 8.83011 11.9191 10.208L11.9504 10.3077C12.0535 10.633 12.0004 10.9883 11.8129 11.2639C11.6254 11.5395 11.3223 11.7055 11.0004 11.7055H1.00038C0.678504 11.7055 0.378504 11.5428 0.187879 11.2639C-0.00274621 10.985 -0.0527462 10.6297 0.0503788 10.3077L0.0816288 10.208C0.512879 8.83011 1.41913 7.72445 2.566 7.06371L2.92225 2.14301H2.00038C1.44725 2.14301 1.00038 1.6682 1.00038 1.08051ZM5.00038 12.768H7.00038V15.9555C7.00038 16.5432 6.5535 17.018 6.00038 17.018C5.44725 17.018 5.00038 16.5432 5.00038 15.9555V12.768Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }